import {
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  NgModule,
  inject,
} from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { FmErrorHandlerService } from './fm-error-handler.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './error-interceptor.service';
import { LoadingState } from './loading.state';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { LayoutState } from './layout.state';
import { AppFeaturesState } from './app-features/app-features.state';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([LoadingState, LayoutState, AppFeaturesState])],
  providers: [
    {
      provide: ErrorHandler,
      useClass: FmErrorHandlerService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,

      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it at bootstrapApplication level only');
    }
  }
}
